import { render, staticRenderFns } from "./item-chart.vue?vue&type=template&id=7863a66e&scoped=true&"
import script from "./item-chart.vue?vue&type=script&lang=js&"
export * from "./item-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7863a66e",
  null
  
)

export default component.exports